import { Controller } from '@hotwired/stimulus';

/**
 * Controller que lo que hace es conectar todos los componentes "obsoletos"
 * (como los data-cifra-type o algunos data-toggle) para que funcione al
 * cargar o recargar el DOM. Esto es transaccional hasta que migremos todos
 * los componentes viejos a controladores
 */
/* global Cifra, $ */
export default class extends Controller {
  connect() {
    Cifra.App.loadComponents(this.element);
    // Recarga del componente de autonuméricos
    // @see https://github.com/BobKnothe/autoNumeric
    window.refresh_autonumeric();
  }
}
